<div class="dashboard-container">
  <app-welcome-message
    [message]="'Welcome ' + (userProfile$ | async)?.firstName + '!'"
    />
    <div class="card-stats-container">
      @if (canShow('FormSubmission')) {
        <app-card-stats
          class="card-stats"
          [title]="'Form Submissions'"
          [value]="totalFormSubmission$ | async"
          [loading]="loadingFormSubmission"
          />
      }
      @if (canShow('MBRReview')) {
        <app-card-stats
          class="card-stats"
          [title]="'MBR Review Requests'"
          [value]="totalMBR$ | async"
          [loading]="loadingMBR"
          />
      }
      @if (canShow('FormConsolidation')) {
        <app-card-stats
          class="card-stats"
          [title]="'Form Consolidation Requests'"
          [value]="totalFormConsolidation$ | async"
          [loading]="loadingFormConsolidation"
          />
      }

      @if (canShow('MarketingMaterial')) {
        <app-card-stats
          class="card-stats"
          [title]="'Marketing Material Submissions'"
          [value]="totalMarketingMaterial$ | async"
          [loading]="loadingMarketingMaterial"
          />
      }
    </div>

    <div class="card-main-container">
      @if (canShow('FormSubmission')) {
        <app-dashboard-card
          class="dashboard-card"
          [title]="'Form Submissions'"
          [listData]="dataFormSubmission$ | async"
          [limitItems]="limitItemFormSubmission"
          [headerRouteLink]="headerRouteFormSubmission"
          [detailRouteLink]="detailRouteFormSubmission"
          [modeFlex]="flexFormSubmission"
          [modeBadge]="badgeSizeFormSubmission"
          [loading]="loadingFormSubmission"
          (goToDetail)="onGoDetail($event, 'formsubmission')"
          />
      }

      @if (canShow('MBRReview')) {
        <app-dashboard-card
          class="dashboard-card"
          [title]="'MBR Review Requests'"
          [listData]="dataMBR$ | async"
          [limitItems]="limitItemMBR"
          [headerRouteLink]="headerRouteMBR"
          [detailRouteLink]="detailRouteMBR"
          [modeFlex]="flexMBR"
          [modeBadge]="badgeSizeMBR"
          [loading]="loadingMBR"
          (goToDetail)="onGoDetail($event, 'mbr')"
          />
      }

      @if (canShow('FormConsolidation')) {
        <app-dashboard-card
          class="dashboard-card"
          [title]="'Form Consolidation Requests'"
          [listData]="dataFormConsolidation$ | async"
          [limitItems]="limitItemFormConsolidation"
          [headerRouteLink]="headerRouteFormConsolidation"
          [detailRouteLink]="detailRouteFormConsolidation"
          [modeFlex]="flexFormConsolidation"
          [modeBadge]="badgeSizeFormConsolidation"
          [loading]="loadingFormConsolidation"
          (goToDetail)="onGoDetail($event, 'formconsolidation')"
          />
      }

      @if (canShow('MarketingMaterial')) {
        <app-dashboard-card
          class="dashboard-card"
          [title]="'Marketing Material Submissions'"
          [listData]="dataMarketingMaterial$ | async"
          [limitItems]="limitItemMarketingMaterial"
          [headerRouteLink]="headerRouteMarketingMaterial"
          [detailRouteLink]="detailRouteMarketingMaterial"
          [modeFlex]="flexMarketingMaterial"
          [modeBadge]="badgeSizeMarketingMaterial"
          [loading]="loadingMarketingMaterial"
          (goToDetail)="onGoDetail($event, 'marketingmaterial')"
          />
      }
    </div>
  </div>
